export default __webpack_public_path__ + "f54da10.png";